import React from 'react';
import './terms.css';

const Terms = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: March 2024</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using RizzologyGPT, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.</p>
        </section>

        <section>
          <h2>2. Service Description</h2>
          <p>RizzologyGPT is an AI-powered conversation assistant designed to help users improve their dating communication skills. The service provides suggestions and feedback but does not guarantee specific outcomes.</p>
        </section>

        <section>
          <h2>3. Subscription and Payments</h2>
          <ul>
            <li>Access to RizzologyGPT requires an active subscription</li>
            <li>Subscription fees are charged according to the selected plan</li>
            <li>All payments are processed securely through Yoco</li>
            <li>Subscriptions automatically expire at the end of the term</li>
            <li>No automatic renewals are implemented</li>
          </ul>
        </section>

        <section>
          <h2>4. User Responsibilities</h2>
          <p>Users agree to:</p>
          <ul>
            <li>Provide accurate information during registration</li>
            <li>Maintain the confidentiality of their account</li>
            <li>Use the service responsibly and ethically</li>
            <li>Not share access to their account</li>
            <li>Not use the service for harassment or harmful purposes</li>
          </ul>
        </section>

        <section>
          <h2>5. Content Guidelines</h2>
          <p>Users must not submit content that is:</p>
          <ul>
            <li>Illegal or promotes illegal activities</li>
            <li>Harassing, abusive, or threatening</li>
            <li>Discriminatory or hateful</li>
            <li>Sexually explicit or pornographic</li>
            <li>Violating others' privacy or rights</li>
          </ul>
        </section>

        <section>
          <h2>6. Limitation of Liability</h2>
          <p>RizzologyGPT provides suggestions and advice but is not responsible for:</p>
          <ul>
            <li>Outcomes of personal interactions</li>
            <li>Success or failure of relationships</li>
            <li>Accuracy of AI-generated responses</li>
            <li>User decisions based on provided advice</li>
          </ul>
        </section>

        <section>
          <h2>7. Contact Information</h2>
          <p>For questions about these terms, please contact us at support@rizzologygpt.com</p>
        </section>
      </div>
    </div>
  );
};

export default Terms; 